module.exports = __webpack_public_path__ + "img/tu@2x.bc83db39.png";